export default __webpack_public_path__ + "static/media/ordering.a78e7932.webp";